import * as React from 'react';
import { useAtomValue } from 'jotai';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { translateThis } from '../../helpers/language.helper';

import { authState } from '../../state/auth.state';
import ApiCaller from '../../services/api/APICaller';
import { showSnackbar } from '../notification';


function ContactForm() {
  const [isLoading, setIsLoading] = React.useState(false);
  const authData = useAtomValue(authState);
  const [formData, setFormData] = React.useState({
    email: authData?.email,
    name: authData?.firstName? `${authData?.firstName} ${authData.lastName}` : '',
    phoneNumber: '',
    subject: '',
    message: '',
  });

  /**
 * sets the form data 
 * @param {string} name the name of the field
 * @param {string} value  the value of the field
 */
  const setFormValue = (name, value) => {
    const formDataAs = { ...formData };
    setFormData({ ...formDataAs, ...{ [name]: value } });
  }

  /**
   * Validates the form and returns true if valid
   * @returns boolean
   */
  const isValidForm = () => {
    let isValid = false;
    if (formData && formData.name &&
      formData.email &&
      formData.message) {
      isValid = true;
    }
    return isValid;
  }

  /**
   * On submit the form
   */
  const onSubmit = () => {
    if (isValidForm()) {
      // Submitting data to backend for registration
      setIsLoading(true);

      const formPostData = {
        name: formData.name,
        email: formData.email,
        occupation: formData.occupation,
        subject: formData.subject,
        phoneNumber: formData.phoneNumber,
        message: formData.message
      }
      const apiCaller = new ApiCaller('messages');

      apiCaller.postData(formPostData).then((data) => {
        if (data.success) {
          setFormValue('message', '')
          showSnackbar().success("Thank you for contacting us!!")
        } else {
          showSnackbar().failure(data.message)

        }
      }).finally(() => setIsLoading(false));
    }
  };


  return (
    <div className='contct-grid-wrp f-wrp'>
      <div className='contct-form-wrp f-wrp'>
        <h3>{translateThis("Contact us")}</h3>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Name")}</h4>
              <TextField                
                margin="dense"
                id="name"
                name="name"
                label=""
                placeholder={translateThis("Your Name")}
                type="text"
                fullWidth
                variant="standard"
                value={formData?.name}
                onChange={(e) => setFormValue('name', e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Occupation")}</h4>
              <TextField
                margin="dense"
                id="Occupation"
                name="Occupation"
                label=""
                placeholder={translateThis("Your occupation")}
                type="text"
                fullWidth
                value={formData?.occupation}
                variant="standard"
                onChange={(e) => setFormValue('Occupation', e.target.value)}
              />
            </div>

          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Email")}</h4>
              <TextField
                margin="dense"
                id="email"
                name="email"
                label=""
                placeholder={translateThis("Your email")}
                type="email"
                fullWidth
                value={formData?.email}
                variant="standard"
                onChange={(e) => setFormValue('email', e.target.value)}
              />
            </div>

          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Phone")}</h4>
              <TextField
                margin="dense"
                id="phone"
                name="phoneNumber"
                label=""
                placeholder={translateThis("Your phone")}
                type="number"
                fullWidth
                value={formData?.phoneNumber}
                variant="standard"
                onChange={(e) => setFormValue('phoneNumber', e.target.value)}
              />
            </div>

          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Subject")}</h4>
              <TextField
                margin="dense"
                id="phone"
                name="subject"
                label=""
                placeholder={translateThis("Subject")}
                type="number"
                fullWidth
                value={formData?.subject}
                variant="standard"
                onChange={(e) => setFormValue('subject', e.target.value)}
              />
            </div>

          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className='each-TextField'>
              <h4>{translateThis("Message")}</h4>
              <TextField
                id="Message"
                name="message"
                label=""
                placeholder={translateThis("Type a message")}
                multiline
                rows={4}
                fullWidth
                value={formData?.message}
                variant="standard"
                onChange={(e) => setFormValue('message', e.target.value)}
              />
            </div>

          </div>
        </div>

        <Button className='sqr-btn' disabled={!isValidForm()} onClick={onSubmit}>{isLoading ? <>{translateThis("Submitting...")}</> : <>{translateThis("Get in touch")}</>}</Button>

      </div>
    </div>
  );
}

export default ContactForm